import { namespace } from "@root/core/constants/constant";
import table from "@store/reducers/pattern/table";

export const name = `${namespace}_web_drama`;

export default table(name);
